import type { TryOnSettingsResponse } from "@sgflabs/opticomm-sdk"
import { callVendorSdk } from "@sgftech/vendor-panel-core/lib/client"
import { useQuery } from "@tanstack/react-query"
import { queryKeysFactory } from "../../lib/query-key-factory"

export const vendorTryOnSettingsQueryKey = queryKeysFactory("vendor_try_on_settings")

export const useVendorTryOnSettings = () => {
  return useQuery({
    queryKey: vendorTryOnSettingsQueryKey.details(),
    queryFn: () =>
      callVendorSdk((opticomm) => opticomm.vendor.tryOn.getSettings<TryOnSettingsResponse>()),
  })
}
